import styled from 'styled-components';
import { themeGet } from 'modules/tetrisTheme';
export const StyledSvg = styled.svg `
  fill: ${({ $inverted = false }) => ($inverted ? themeGet('colors.gray.0') : themeGet('colors.gray.1000'))};
`;
